import React from 'react';

export const DOBCalendarIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clip-path="url(#clip0_986_6866)">
        <path
          d="M6.88656 11.4399H7.83289C8.01273 11.4399 8.15851 11.5857 8.15851 11.7656V12.7119C8.15851 12.8917 8.01273 13.0375 7.83289 13.0375H6.88656C6.70672 13.0375 6.56094 12.8917 6.56094 12.7119V11.7656C6.56094 11.5857 6.70672 11.4399 6.88656 11.4399Z"
          fill="#005D98"
        />
        <path
          d="M7.83289 13.7708H6.88656C6.70672 13.7708 6.56094 13.9166 6.56094 14.0964V15.0428C6.56094 15.2226 6.70672 15.3684 6.88656 15.3684H7.83289C8.01273 15.3684 8.15851 15.2226 8.15851 15.0428V14.0964C8.15851 13.9166 8.01273 13.7708 7.83289 13.7708Z"
          fill="#005D98"
        />
        <path
          d="M6.88656 16.1011H7.83289C8.01273 16.1011 8.15851 16.2469 8.15851 16.4267V17.373C8.15851 17.5529 8.01273 17.6987 7.83289 17.6987H6.88656C6.70672 17.6987 6.56094 17.5529 6.56094 17.373V16.4267C6.56094 16.2469 6.70672 16.1011 6.88656 16.1011Z"
          fill="#005D98"
        />
        <path
          d="M10.1532 11.4399H9.20687C9.02704 11.4399 8.88125 11.5857 8.88125 11.7656V12.7119C8.88125 12.8917 9.02704 13.0375 9.20687 13.0375H10.1532C10.333 13.0375 10.4788 12.8917 10.4788 12.7119V11.7656C10.4788 11.5857 10.333 11.4399 10.1532 11.4399Z"
          fill="#005D98"
        />
        <path
          d="M9.20687 13.7708H10.1532C10.333 13.7708 10.4788 13.9166 10.4788 14.0964V15.0428C10.4788 15.2226 10.333 15.3684 10.1532 15.3684H9.20687C9.02704 15.3684 8.88125 15.2226 8.88125 15.0428V14.0964C8.88125 13.9166 9.02704 13.7708 9.20687 13.7708Z"
          fill="#005D98"
        />
        <path
          d="M10.1532 16.1011H9.20687C9.02704 16.1011 8.88125 16.2469 8.88125 16.4267V17.373C8.88125 17.5529 9.02704 17.6987 9.20687 17.6987H10.1532C10.333 17.6987 10.4788 17.5529 10.4788 17.373V16.4267C10.4788 16.2469 10.333 16.1011 10.1532 16.1011Z"
          fill="#005D98"
        />
        <path
          d="M11.5166 11.4399H12.463C12.6428 11.4399 12.7886 11.5857 12.7886 11.7656V12.7119C12.7886 12.8917 12.6428 13.0375 12.463 13.0375H11.5166C11.3368 13.0375 11.191 12.8917 11.191 12.7119V11.7656C11.191 11.5857 11.3368 11.4399 11.5166 11.4399Z"
          fill="#005D98"
        />
        <path
          d="M12.463 13.7708H11.5166C11.3368 13.7708 11.191 13.9166 11.191 14.0964V15.0428C11.191 15.2226 11.3368 15.3684 11.5166 15.3684H12.463C12.6428 15.3684 12.7886 15.2226 12.7886 15.0428V14.0964C12.7886 13.9166 12.6428 13.7708 12.463 13.7708Z"
          fill="#005D98"
        />
        <path
          d="M11.5166 16.1011H12.463C12.6428 16.1011 12.7886 16.2469 12.7886 16.4267V17.373C12.7886 17.5529 12.6428 17.6987 12.463 17.6987H11.5166C11.3368 17.6987 11.191 17.5529 11.191 17.373V16.4267C11.191 16.2469 11.3368 16.1011 11.5166 16.1011Z"
          fill="#005D98"
        />
        <path
          d="M14.7727 11.4399H13.8264C13.6466 11.4399 13.5008 11.5857 13.5008 11.7656V12.7119C13.5008 12.8917 13.6466 13.0375 13.8264 13.0375H14.7727C14.9526 13.0375 15.0984 12.8917 15.0984 12.7119V11.7656C15.0984 11.5857 14.9526 11.4399 14.7727 11.4399Z"
          fill="#005D98"
        />
        <path
          d="M13.8264 13.7708H14.7727C14.9526 13.7708 15.0984 13.9166 15.0984 14.0964V15.0428C15.0984 15.2226 14.9526 15.3684 14.7727 15.3684H13.8264C13.6466 15.3684 13.5008 15.2226 13.5008 15.0428V14.0964C13.5008 13.9166 13.6466 13.7708 13.8264 13.7708Z"
          fill="#005D98"
        />
        <path
          d="M14.7727 16.1011H13.8264C13.6466 16.1011 13.5008 16.2469 13.5008 16.4267V17.373C13.5008 17.5529 13.6466 17.6987 13.8264 17.6987H14.7727C14.9526 17.6987 15.0984 17.5529 15.0984 17.373V16.4267C15.0984 16.2469 14.9526 16.1011 14.7727 16.1011Z"
          fill="#005D98"
        />
        <path
          d="M16.1467 11.4399H17.093C17.2729 11.4399 17.4187 11.5857 17.4187 11.7656V12.7119C17.4187 12.8917 17.2729 13.0375 17.093 13.0375H16.1467C15.9669 13.0375 15.8211 12.8917 15.8211 12.7119V11.7656C15.8211 11.5857 15.9669 11.4399 16.1467 11.4399Z"
          fill="#005D98"
        />
        <path
          d="M17.093 13.7708H16.1467C15.9669 13.7708 15.8211 13.9166 15.8211 14.0964V15.0428C15.8211 15.2226 15.9669 15.3684 16.1467 15.3684H17.093C17.2729 15.3684 17.4187 15.2226 17.4187 15.0428V14.0964C17.4187 13.9166 17.2729 13.7708 17.093 13.7708Z"
          fill="#005D98"
        />
        <path
          d="M16.1467 16.1011H17.093C17.2729 16.1011 17.4187 16.2469 17.4187 16.4267V17.373C17.4187 17.5529 17.2729 17.6987 17.093 17.6987H16.1467C15.9669 17.6987 15.8211 17.5529 15.8211 17.373V16.4267C15.8211 16.2469 15.9669 16.1011 16.1467 16.1011Z"
          fill="#005D98"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.5582 4.89744C19.0771 4.89744 19.5147 5.07042 19.881 5.4164H19.8505C20.2168 5.76237 20.4 6.17957 20.4 6.668V18.9907C20.4 20.0388 19.5554 20.8834 18.5073 20.8834H5.4723C4.95334 20.8834 4.51578 20.7104 4.14946 20.3644C3.78314 20.0185 3.59998 19.6013 3.59998 19.1128V6.668C3.59998 6.17957 3.78314 5.76237 4.14946 5.4164C4.51578 5.07042 4.96351 4.89744 5.4723 4.89744H6.40846V4.05286C6.40846 3.5339 6.82566 3.1167 7.34461 3.1167C7.86357 3.1167 8.28077 3.5339 8.28077 4.05286V4.89744H15.7497V4.05286C15.7497 3.5339 16.1669 3.1167 16.6859 3.1167C17.2048 3.1167 17.622 3.5339 17.622 4.05286V4.89744H18.5582ZM5.49265 19.1128H18.5582V10.2295H5.49265V19.1128ZM5.49265 8.44874H18.5582V6.668H5.49265V8.44874Z"
          fill="#005D98"
        />
      </g>
      <defs>
        <clipPath id="clip0_986_6866">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
